<template>
	<div>
		<v-snackbar v-model="snackbar.show" top :color="snackbar.color" :timeout="snackbar.timeout">
			{{ snackbar.message }}
			<v-btn :color="snackbar.buttonColor" flat @click="snackbar.show = false">
				Close
			</v-btn>
		</v-snackbar>
		<v-snackbar v-model="goalSavedNotif" top>
			Goal Saved
			<v-btn color="pink" flat @click="goalSavedNotif = false">Close</v-btn>
		</v-snackbar>
		<v-layout row wrap>
			<v-flex lg6>
				<v-card style="margin-left: 10px; margin-right: 10px; margin-top:10px; margin-top: 10px;">
					<v-toolbar flat dense cad>
						<v-toolbar-title class="subheading">{{ performanceReview.employee.fullName }}</v-toolbar-title>
						<v-spacer></v-spacer>

						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon flat @click="print" v-on="on">
									<v-badge color="red" overlap>
										<v-icon medium>print</v-icon>
									</v-badge>
								</v-btn>
							</template>
							<span>Print Discussion</span>
						</v-tooltip>
					</v-toolbar>
					<v-list two-line>
						<v-list-tile inactive>
							<v-list-tile-action>
								<v-avatar size="36px">
									<img :src="getAvatar(performanceReview.employee.id)" alt="avatar" class="avatar-img" />
								</v-avatar>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>{{ performanceReview.position !== null ? performanceReview.position.title : 'N/A' }}</v-list-tile-title>
								<v-list-tile-sub-title>Job Title</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
					<div v-if="isDefaultReviewType" class="pd-container">
						<h2>Position Purpose</h2>
						<p>{{ performanceReview.position !== null ? performanceReview.position.description : '' }}</p>
					</div>
				</v-card>
			</v-flex>
		</v-layout>
		<v-alert style="margin-top:20px; text-align:left;" :value="!isDiscussion && !isComplete" color="warning" icon="priority_high" outline
			>This section can not be filled out until both the employee and reviewer have submitted their reviews.</v-alert
		>

		<v-divider style="margin-top:30px; margin-bottom: 20px;"></v-divider>

		<v-card class="mb-4" style="margin-left: 10px; margin-right: 10px; margin-top:10px; margin-top: 10px;">
			<v-toolbar flat dense cad color="info" dark>
				<v-toolbar-title class="subheading">Discussion Notes</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>
			<v-divider></v-divider>

			<v-card-text class>
				<div v-for="group in discussionItems" :key="group.group" class="type">
					<div class="text-xs-left">
						<h2 style="margin-bottom: 20px; margin-top:10px;">{{ group.group }}</h2>
						<h5 v-if="group.type == '3'">This is the team members opportunity to provide qualified and specific feedback to their Manager</h5>
					</div>
					<div v-for="t in group.items" :key="t.id">
						<div class="text-xs-left">
							<h4 v-if="t.category !== 'N/A'" style="margin-top:30px; margin-bottom:20px; color: rgba(0,0,0,0.54);">{{ t.category }}</h4>
						</div>
						<div v-for="s in t.items" :key="s.id" class="item">
							<performance-review-discussion-item
								:discussion-item="s"
								:employee="performanceReview.employee"
								:reviewer="performanceReview.reviewer"
								:is-discussion="isDiscussion"
								:logged-in-employee="loggedInEmployee"
								@onAddGoal="onAddGoal"
								@onNotesUpdated="onNotesUpdated"
								@onEditItem="onShowItemEditor"
							/>
						</div>
					</div>
				</div>

				<div v-if="isDefaultReviewType">
					<v-layout row wrap>
						<v-flex sm6>
							<h2 class="text-xs-left">Other Duties</h2>
							<h5 class="text-xs-left" style="margin-top:10px; margin-bottom: 10px;">Q. Are there any other duties that you are currently doing that have not been listed?</h5>

							<v-subheader v-if="performanceReview.employeeSubmit.otherDuties === null" class="text-xs-left">N/A</v-subheader>

							<table v-if="performanceReview.employeeSubmit.otherDuties != null" class="comment" v-on="on">
								<tr>
									<td>
										<v-avatar size="36px">
											<img :src="getAvatar(performanceReview.employee.id)" alt="avatar" class="avatar-img" />
										</v-avatar>
									</td>
									<td>
										<v-subheader style="height: inherit;" class="text-xs-left comment-text">{{ performanceReview.employeeSubmit.otherDuties }}</v-subheader>
									</td>
								</tr>
							</table>
						</v-flex>
						<v-flex sm6>
							<h2 class="text-xs-left">Reviewer Notes</h2>
							<v-subheader v-if="performanceReview.reviewerSubmit.notes === null" class="text-xs-left">N/A</v-subheader>

							<table v-if="performanceReview.reviewerSubmit.notes != null" class="comment" v-on="on">
								<tr>
									<td>
										<v-avatar size="36px">
											<img :src="getAvatar(performanceReview.reviewer.id)" alt="avatar" class="avatar-img" />
										</v-avatar>
									</td>
									<td>
										<v-subheader style="height: inherit;" class="text-xs-left comment-text">{{ performanceReview.reviewerSubmit.notes }}</v-subheader>
									</td>
								</tr>
							</table>
						</v-flex>
					</v-layout>

					<v-divider style="margin-bottom:20px;"></v-divider>
				</div>

				<div v-if="isDefaultReviewType">
					<v-layout row wrap>
						<v-flex sm6>
							<h2 class="text-xs-left">Concerns</h2>
							<h5 class="text-xs-left" style="margin-top:10px; margin-bottom: 10px;">Q. Do you have any concerns regarding your job?</h5>

							<v-subheader v-if="performanceReview.employeeSubmit.concerns === null" class="text-xs-left">N/A</v-subheader>

							<table v-if="performanceReview.employeeSubmit.concerns != null" class="comment" v-on="on">
								<tr>
									<td>
										<v-avatar size="36px">
											<img :src="getAvatar(performanceReview.employee.id)" alt="avatar" class="avatar-img" />
										</v-avatar>
									</td>
									<td>
										<v-subheader style="height: inherit;" class="text-xs-left comment-text">{{ performanceReview.employeeSubmit.concerns }}</v-subheader>
									</td>
								</tr>
							</table>
						</v-flex>
					</v-layout>

					<v-divider style="margin-bottom:20px;"></v-divider>
				</div>

				<div class="noPrint" v-if="isDiscussion">
					<h2 class="text-xs-left noPrint">Add Goals</h2>

					<h5 v-if="isDefaultReviewType" class="text-xs-left noPrint" style="margin-top:10px; margin-bottom: 10px;">This is a good opportunity to add in any goals for the next review period.</h5>

					<div class="add-goal-panel summary text-xs-left">
						<v-btn :disabled="!isDiscussion" depressed small class="noPrint" @click="onAddGoal">Create a Goal</v-btn>
					</div>

					<v-divider style="margin-bottom:20px;"></v-divider>
				</div>

				<div class="noPrint" v-if="isDiscussion || form.notes">
					<h2 class="text-xs-left">Final Notes</h2>

					<h5 v-if="isDefaultReviewType" class="text-xs-left noPrint" style="margin-top:10px; margin-bottom: 10px;">This is a good opportunity to add in any commitments, actionables, and objectives for the next review period.</h5>

					<v-textarea v-model="form.notes" auto-grow :readonly="!isDiscussion" box label="Final Notes" rows="3" :class="{ 'readonly-textarea': !isDiscussion }" :prepend-icon="!isDiscussion ? 'mdi-playlist-edit' : ''"></v-textarea>
				</div>
			</v-card-text>
		</v-card>

		<v-footer class="noPrint" color app height="55">
			<v-spacer></v-spacer>

			<span class="last-saved-date ml-1 mr-2" v-if="isDiscussion && autoSave && lastSavedDate">(Last saved <AppDate :date="lastSavedDate" format="hh:mm a" prepend-tooltip="Last saved" show-date />)</span>
			<v-switch v-if="isDiscussion" v-model="autoSave" label="Auto Save" class="mr-2" style="flex:none;"></v-switch>

			<footer-back-btn @click="cancel" />
			<v-btn v-if="isDiscussion && !autoSave" @click="save(false, false)" color="primary" :disabled="isSaving" :loading="isSaving">Save <span slot="loader">Saving...</span></v-btn>
			<v-btn v-if="isDiscussion" class="action-btn" dark @click="onSignOffClick" :loading="isSubmitting">Save & Sign Off <span slot="loader">Saving...</span></v-btn>
		</v-footer>

		<employee-goal-editor
			v-if="goalEditorDialog"
			:title="goalEditorTitle"
			:dialog="goalEditorDialog"
			:goal="editedGoal"
			:allow-complete-on-create="false"
			:employeeId="performanceReview.employee.id"
			@onSaved="onGoalSaved"
			@onDeleted="onGoalDeleted"
			@closeEditor="goalEditorDialog = false"
		></employee-goal-editor>

		<discussion-sign-off :dialog="showDiscussionSignOff" @onSignOff="onSignOff" @onCancel="onCancelSignOff" />
	</div>
</template>

<script>
	import EmployeeGoalEditor from '@/components/employee/EmployeeGoalEditor';
	import PerformanceReviewDiscussionItem from '@/components/performanceReview/PerformanceReviewDiscussionItem';
	import DiscussionSignOff from '@/components/performanceReview/DiscussionSignOff';
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';
	import avatarMixin from '@/mixins/avatarMixin';
	import performanceReviewItemsMixin from '@/mixins/performanceReviewItemsMixin';

	let autoSaveTimeoutId;

	export default {
		props: {
			performanceReview: {
				required: true
			},
			loggedInEmployee: {
				type: Object,
				required: true
			}
		},
		mixins: [typeFriendlyMixin, avatarMixin, performanceReviewItemsMixin],
		components: {
			EmployeeGoalEditor,
			PerformanceReviewDiscussionItem,
			DiscussionSignOff
		},
		data() {
			return {
				form: null,
				goalEditorDialog: false,
				editedGoalIndex: -1,
				editedGoal: undefined,
				goalSavedNotif: false,
				goalDeletedNotif: false,
				autoSave: true,
				lastSavedDate: null,
				isSaving: false,
				isSubmitting: false,
				snackbar: {
					show: false,
					message: '',
					color: undefined,
					buttonColor: 'pink',
					timeout: 6000
				},
				showDiscussionSignOff: false,
				on: undefined
			};
		},
		created() {
			this.form = {
				performanceReviewId: this.performanceReview.id,
				id: this.performanceReview.discussion.id,
				notes: this.performanceReview.discussion.notes,
				items: this.performanceReview.discussion.items.map(discussionItem => {
					return {
						id: discussionItem.id,
						notes: discussionItem.notes
					};
				})
			};
		},
		watch: {
			formSerialised(newVal, oldVal) {
				if (this.autoSave && oldVal != 'null') {
					// If a timer was already started, clear it.
					if (autoSaveTimeoutId) clearTimeout(autoSaveTimeoutId);

					autoSaveTimeoutId = setTimeout(() => {
						if (!this.isSaving && !this.isSubmitting) {
							this.save(true, false);
						}
					}, 2000);
				}
			}
		},
		computed: {
			formSerialised() {
				return JSON.stringify(this.form);
			},
			isDefaultReviewType() {
				return this.performanceReview.type === 0;
			},
			isDiscussion() {
				return this.performanceReview.status === 'Discussion';
			},
			isComplete() {
				return this.performanceReview.status === 'Complete';
			},
			discussionItems() {
				let extended = this.performanceReview.discussion.items.map(discussionItem => {
					// Find Employee Submit Item
					let employeeItem = this.performanceReview.employeeSubmit.items.find(x => x.id == discussionItem.id);

					// Find Reviewer Submit Item
					let reviewerItem = this.performanceReview.reviewerSubmit.items.find(x => x.id == discussionItem.id);

					discussionItem.employeeItem = employeeItem;
					discussionItem.reviewerItem = reviewerItem;

					return discussionItem;
				});

				return this.getReviewItemsSorted(extended, 'item.group', 'item.category');
			},
			reviewerItems() {
				return this.getReviewItemsSorted(this.performanceReview.reviewerSubmit.items, 'item.group', 'item.category');
			},
			employeeItems() {
				return this.getReviewItemsSorted(this.performanceReview.employeeSubmit.items, 'item.group', 'item.category');
			},
			goalEditorTitle() {
				return this.editedGoalIndex === -1 ? 'Create Goal' : 'Edit Goal';
			}
		},
		methods: {
			onNotesUpdated({ id, notes }) {
				const index = this.form.items.indexOf(this.form.items.find(x => x.id == id));
				if (index > -1) {
					this.form.items[index].notes = notes;
				}
			},
			onEditGoal(item) {
				this.editedGoalIndex = this.goals.indexOf(item);
				this.editedGoal = Object.assign({}, item);
				this.goalEditorDialog = true;
			},
			onAddGoal(discussionItemId) {
				this.editedGoalIndex = -1;
				this.editedGoal = undefined;
				this.goalEditorDialog = true;
			},
			onGoalDeleted(id) {
				const index = this.goals.indexOf(this.goals.filter(x => x.id == id));
				this.goals.splice(index, 1);
				this.goalDeletedNotif = true;
				this.goalEditorDialog = false;
			},
			onGoalSaved(goal) {
				this.goalEditorDialog = false;
				this.goalSavedNotif = true;
			},
			save(viaAutoSave, signOff) {
				if (viaAutoSave) {
					console.log('Autosaving...');
				} else {
					if (signOff) {
						this.isSubmitting = true;
					} else {
						this.isSaving = true;
					}
				}

				let postItems = [];
				postItems = this.form.items;

				let postObj = {
					id: this.form.id,
					notes: this.form.notes,
					signOff: signOff,
					performanceReviewId: this.form.performanceReviewId,
					items: postItems
				};

				// Save
				this.$store.dispatch('performanceReviews/postDiscussion', postObj).then(
					response => {
						this.isSubmitting = false;
						this.isSaving = false;

						if (signOff) {
							this.$router.push(`/pr/${this.performanceReview.id}`);
						} else {
							if (!viaAutoSave) {
								this.showSnackbar('Performance Review Saved');
							}

							this.lastSavedDate = new Date();
						}
					},
					error => {
						this.isSubmitting = false;
						this.isSaving = false;

						let errorMessage = 'An error has occurred whilst saving the Discussion: ';
						if (error) {
							if (error.response && error.response.status === 401) {
								errorMessage += 'You have been logged out. Please refresh the page to log back in.';
							} else if (error.message) {
								errorMessage += error.message;
							}
						}

						this.showSnackbar(errorMessage, true);
					}
				);
			},
			showSnackbar(message, isError) {
				this.snackbar.show = true;
				this.snackbar.message = message;
				this.snackbar.color = isError ? 'error' : undefined;
				this.snackbar.buttonColor = isError ? '#fff' : 'pink';
				this.snackbar.timeout = isError ? 0 : 6000;
			},
			print() {
				window.print();
			},
			cancel() {
				window.history.back();
			},
			onSignOffClick() {
				this.showDiscussionSignOff = true;
			},
			onSignOff() {
				this.save(false, true);
				this.showDiscussionSignOff = false;
			},
			onCancelSignOff() {
				this.showDiscussionSignOff = false;
			},
			onShowItemEditor(item) {
				this.$emit('onShowItemEditor', item);
			}
		}
	};
</script>

<style scoped></style>
